﻿
class filterResults {
    public shape: object;
    public availableShapes: [any];
}



class benchShapeFilter {
    public filterShapes(currentShape, availableShapes, measurements) {
        let shapes = availableShapes.filter(s => this.shapeFitsConstraints(s, measurements));
        let result = new filterResults();
        if (shapes.length>0) {
            result.availableShapes = shapes;
            if (this.shapeFitsConstraints(currentShape, measurements)) {
                result.shape = currentShape;
            }
            else {
                result.shape = shapes[0];
            }
        }
        else {        
            result.shape = currentShape;
            result.availableShapes = [currentShape];            
        }
        return result;
           
    }
    public shapeFitsConstraints(shape, measurements) {
        return shape.mininimumSaunaSize.width <= measurements.doorWallWidth && shape.mininimumSaunaSize.depth <= measurements.depth;
    }

}
export default benchShapeFilter;